"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const graphql_1 = require("../../../graphql");
const BaseAuthModal_1 = require("./BaseAuthModal");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
// interface IState {}
exports.SignUpModal = props => {
    const { history: { push }, } = use_react_router_1.default();
    return (react_1.default.createElement(BaseAuthModal_1.BaseAuthModal, Object.assign({ osysSubType: "signup", title: "Sign up for Osmosys", fields: ['fullName', 'email', 'password'], mutation: graphql_1.signup, buttonText: "Sign up", linkComp: react_1.default.createElement("p", { className: "text-muted" },
            "or ",
            react_1.default.createElement(react_router_dom_1.Link, { to: "/login" }, "login to existing account"),
            "."), onCompleted: () => {
            push('/');
        }, getVars: values => ({
            data: {
                email: values.email,
                fullName: values.fullName,
                password: values.password,
            },
        }) }, props)));
};
exports.default = exports.SignUpModal;
//# sourceMappingURL=SignUpModal.js.map